import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAdmin } from "../../contexts/AdminContext";

export default function PageTitleHandler() {
  const { settings } = useAdmin();
  const location = useLocation();

  useEffect(() => {
    const siteName = settings.siteName || "Traumhausverlosung";
    let pageName = "";

    switch (location.pathname) {
      case "/": pageName = "Accueil"; break;
      case "/bien": pageName = "La Villa"; break;
      case "/forfaits": pageName = "Forfaits & Tickets"; break;

      case "/contact": pageName = "Support & Aide"; break;
      case "/compte": pageName = "Mon Compte"; break;
      case "/admin": pageName = "Administration"; break;
      default: pageName = "";
    }

    document.title = pageName ? `${pageName} | ${siteName}` : siteName;

    // SEO updates
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute("content", settings.metaDescription || "La loterie immobilière premium.");
    } else {
      const meta = document.createElement('meta');
      meta.name = "description";
      meta.content = settings.metaDescription || "La loterie immobilière premium.";
      document.head.appendChild(meta);
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute("content", settings.metaKeywords || "loterie, villa, luxe");
    } else {
      const meta = document.createElement('meta');
      meta.name = "keywords";
      meta.content = settings.metaKeywords || "loterie, villa, luxe";
      document.head.appendChild(meta);
    }

    // Favicon update
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon && settings.favicon) {
      favicon.setAttribute("href", settings.favicon);
    }
  }, [location.pathname, settings.siteName, settings.metaDescription, settings.metaKeywords, settings.favicon]);

  return null;
}
